module.exports = __webpack_public_path__ + "img/htcm_02.8c4372c7.jpg";